import React from "react";
import CircularProgress, { CircularProgressProps } from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";

export default function CircularProgressWithLabel(props: CircularProgressProps & { value: number; labelSize?: string }) {
	return (
		<Box position="relative" display="inline-flex">
			<CircularProgress variant="determinate" {...props} />
			<Box top={0} left={0} bottom={0} right={0} position="absolute" display="flex" alignItems="center" justifyContent="center">
				<Typography
					style={{ fontSize: props.labelSize ? props.labelSize : undefined }}
					variant="caption"
					component="div"
					color={props.color ? props.color : "textPrimary"}
				>{`${Math.round(props.value)}%`}</Typography>
			</Box>
		</Box>
	);
}
